module.exports = __webpack_public_path__ + "static/img/图层2.256ee72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/图层2.png
// module id = 9zfP
// module chunks = 192